import axios from 'axios';

export default {
    
    data() {
        return {
            urlApi: process.env.VUE_APP_ROOT_API,
            token: JSON.parse(this.$store.getters.getUser).access_token,
            value: null,
        }
    },

    get(endpoint, callback, loading) {
        loading.showLoading();
        const url = `${process.env.VUE_APP_ROOT_API}/v1/${endpoint}`;
        axios.get(url, { headers: { 'Content-Type': 'application/json', 'Authorization': this.token } })
            .then(response => callback(response))
            .catch(error => this.exibirErro(error))
            .finally(() => loading.hideLoading())
    },

    exibirErro(error) {
        // if (error.response != null && error.response.data != null) {
        //     this.$store.commit("setMessages", { message: 'Erro!', variant: 'danger', errors: [error.response.data] });
        // } else {
        //     this.$store.commit("setMessages", { message: 'Erro!', variant: 'danger', errors: [error] });
        // }
        // window.scrollTo(0, 0);
    },

}
